import { useMemo } from 'react'

import { useRouter } from 'next/router'

export interface UseTicketsNoLongerAvailableResult {
    readonly areTicketsNoLongerAvailable: boolean
}

const useTicketsNoLongerAvailable = (): UseTicketsNoLongerAvailableResult => {
    const {
        query: { notix, tixpurchased },
    } = useRouter()

    const areTicketsNoLongerAvailable: boolean = useMemo(() => !!notix || !!tixpurchased, [notix, tixpurchased])
    return { areTicketsNoLongerAvailable }
}

export default useTicketsNoLongerAvailable
